import HeroText from "../../components/heros/hero-text";
import AboutInnovation from "./components/about-innovation/about-innovation";
import AboutGrowing from "./components/about-growing/about-growing";
import AboutTheBeginnins from "./components/about-the-beginnins/about-the-beginnins";
import AboutBirth from "./components/about-birth/about-birth";
import AboutDevelopment from "./components/about-development/about-development";
import AboutReliability from "./components/about-reliability/about-reliability";
import AboutTimeLine from "./components/about-time-line/about-time-line";
import AboutContactUs from "./components/about-contact-us/about-contact-us";

const AboutUs: React.FC = () => {
  return (
    <div className="about">
      <HeroText
        title="Chi Siamo"
        text="Una storia di innovazione e competenza nelle opere di fondazione e consolidamento, iniziata nel 1997 e cresciuta fino a diventare un punto di riferimento per le costruzioni speciali."
      />
      <AboutTheBeginnins />
      <AboutInnovation />
      <AboutGrowing />
      <AboutBirth />
      <AboutDevelopment />
      <AboutReliability />
      <AboutTimeLine />
      <AboutContactUs />
    </div>
  );
};

export default AboutUs;
